export interface Department {
  id: string;
  department_Name: string;
  department_Code: string;
  department_Description: string;
  department_Email: string;
  department_Phone_Number: string;
  isDeleted: boolean;
  isActive: boolean;
  roleId: string;
  customerName: string;
  // shelfRackItemByDepartment: [];
}
export const DepartmentInitialState = {
  id: '',
  department_Name: '',
  department_Code: '',
  department_Description: '',
  department_Email: '',
  department_Phone_Number: '',
  isDeleted: false,
  isActive: true,
  roleId: '',
  customerName: '',
};
